import { Phone, MessageCircle } from "lucide-react";
import { useContent } from "../contexts/ContentContext";

export default function FloatingCTA() {
  const { content } = useContent();
  const s = content?.settings || {};
  if (!s.phone && !s.whatsapp) return null;
  const waMsg = encodeURIComponent(s.whatsapp_message || "Hi, I'm interested in your courses.");

  return (
    <div className="fixed bottom-6 right-6 lg:bottom-8 lg:right-8 z-40 flex flex-col gap-3">
      {s.whatsapp && (
        <a
          href={`https://wa.me/${s.whatsapp}?text=${waMsg}`}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="floating-whatsapp"
          aria-label="WhatsApp"
          className="h-14 w-14 rounded-full flex items-center justify-center text-white shadow-xl hover:-translate-y-1 transition-transform"
          style={{ backgroundColor: "#25D366" }}
        >
          <MessageCircle className="h-6 w-6" />
        </a>
      )}
      {s.phone && (
        <a
          href={`tel:${s.phone}`}
          data-testid="floating-call"
          aria-label="Call"
          className="h-14 w-14 rounded-full flex items-center justify-center text-white shadow-xl hover:-translate-y-1 transition-transform bg-primary hover:bg-[#059669]"
        >
          <Phone className="h-6 w-6" />
        </a>
      )}
    </div>
  );
}
